import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    class: "popover-wrapper",
    "popper-class": "tooltip-popover",
    teleported: $props.teleported,
    disabled: $options.disable_tooltip,
    "z-index": 3001,
    "show-arrow": false,
    trigger: "hover",
    "show-after": 100,
    transition: "none",
    persistent: false,
    "popper-style": {maxWidth: $props.maxWidth}
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      _createTextVNode(" " + _toDisplayString($props.text), 1 /* TEXT */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["teleported", "disabled", "popper-style"]))
}